var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClasslist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 87,
    viewBox: "0 0 130 87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-classlist_svg__a",
    width: "145.3%",
    height: "139.3%",
    x: "-22.6%",
    y: "-19.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.261090472 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E67649",
    d: "M58.671 30.863L60 30c13.308-8.719 43.5-17 45-8 5.463 32.776-10.192 53.908-19.18 55.244C74 79 33.5 66 27.432 58.84c-5.504-6.494 16.669-18.588 31.238-27.978z",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-classlist_svg__a)",
    transform: "translate(39 9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C5B3F7",
    d: "M0 0v60.891h39.332V48.014H52.26V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A090C4",
    d: "M13.531 12.26h11.832V5.267H13.531zm0 8.293h11.832v-6.992H13.531zm0 8.293h11.832v-6.993H13.531zm0 8.293h11.832v-6.992H13.531zm0 8.294h11.832V38.44H13.531zm0 8.293h11.832v-6.993H13.531z",
    opacity: 0.803
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D68A5",
    d: "M5.752 12.26h6.602V5.267H5.752zm0 8.293h6.602v-6.992H5.752zm0 8.293h6.602v-6.993H5.752zm0 8.293h6.602v-6.992H5.752zm0 8.294h6.602V38.44H5.752zm0 8.293h6.602v-6.993H5.752z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A090C4",
    d: "M26.541 12.26h19.968V5.267H26.541zm0 8.293h19.968v-6.992H26.541zm0 8.293h19.968v-6.993H26.541zm0 8.293h19.968v-6.992H26.541zm0 8.294h19.968V38.44H26.541zm0 8.293h19.968v-6.993H26.541z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.331 48.015V60.89L52.26 48.015z"
  })))));
}

export default __webpack_public_path__ + "7683920e1256861fe6bfee4c53d72d46.svg";
export { SvgIconClasslist as ReactComponent };